import React, { useState } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Alert
} from '@mui/material';
import Grid from '@mui/material/Grid';

const DoctorProcedures: React.FC = () => {
  const [procedures] = useState<any[]>([]);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Proceduri & Interventii
      </Typography>

      <Alert severity="info" sx={{ mb: 3 }}>
        <Typography variant="body2">
          Modul de proceduri dedicate nu este disponibil end-to-end in aceasta versiune.
        </Typography>
        <ul style={{ marginTop: '8px', marginBottom: 0 }}>
          <li>Fluxul oficial pentru consultatie este in ecranul de encounter al vizitei.</li>
          <li>Datele clinice se salveaza in formularul vizitei (inclusiv tratamente).</li>
          <li>Acest ecran este intentionat read-only pana la unificarea modelului de proceduri.</li>
        </ul>
      </Alert>

      {procedures.length === 0 ? (
        <Card>
          <CardContent>
            <Typography variant="body1" color="text.secondary" align="center">
              Nu exista proceduri programate
            </Typography>
          </CardContent>
        </Card>
      ) : (
        <Grid container spacing={2}>
          {procedures.map((proc) => (
            <Grid size={{ xs: 12, md: 6 }} key={proc.id}>
              <Card>
                <CardContent>
                  <Typography variant="h6">{proc.procedure_name}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {proc.patient?.name}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default DoctorProcedures;

